
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MokYun extends Vue {
  public configInfo: any = [];
  @Prop() private msg!: any;
  school() {
    window.open(this.msg[0].schoolUrl, '_blank');
  }
  student() {
    window.open(this.msg[0].recruitUrl, '_blank');
  }
  goBottom() {
    const height = document.body.clientHeight;
    scrollTo(height, height);
  }
}
